import Layout from '@layout/FreeLayout/FreeLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import UpscCurrentAffairsDetailedPageHero from '@cont/UpscCurrentAffairs/UpscCurrentAffairsDetailedPageHero';
import UpscCurrentAffairsDetailedPageBody, {
  UpscDetailedPageCanvas
} from '@cont/UpscCurrentAffairs/UpscCurrentAffairsDetailedPageBody';
import UpscCurrentAffairsFaq from '@cont/UpscCurrentAffairs/UpscCurrentAffairsFaq';
import UpscCurrentAffairsSeo from '@cont/UpscCurrentAffairs/UpscCurrentAffairsSeo';
import { UpscCurrentAffairsPageSeoProps } from '@cont/UpscCurrentAffairs/upscSeoTypes';
import setupInitialProps from '@utils/setupInitialProps';
import getUpscDetailedPageInitialProps from '@cont/UpscCurrentAffairs/upscDetailedPageInitialProps';

const UpscCurrentAffairsDetailedPage = ({
  upscPageSeo,
  canonicalPath
}: UpscCurrentAffairsPageSeoProps) => (
  <>
    <UpscCurrentAffairsSeo
      pageSeo={upscPageSeo}
      canonicalPath={canonicalPath}
    />
    <UpscCurrentAffairsDetailedPageHero />
    <UpscDetailedPageCanvas>
      <UpscCurrentAffairsDetailedPageBody />
      <UpscCurrentAffairsFaq faqSessionKey="detailedArticlePage" />
    </UpscDetailedPageCanvas>
  </>
);

UpscCurrentAffairsDetailedPage.pageInfo = {
  name: 'UPSC Current Affairs — Detailed Page',
  isMWebSupported: true,
  layoutOptions: {
    hideIntercom: true,
    hideGoalSelector: true
  }
};

UpscCurrentAffairsDetailedPage.getInitialProps = setupInitialProps(
  getUpscDetailedPageInitialProps('detailPageSeo'),
  UpscCurrentAffairsDetailedPage.pageInfo
);

export default UpscCurrentAffairsDetailedPage;
UpscCurrentAffairsDetailedPage.Layout = Layout;
UpscCurrentAffairsDetailedPage.Wrapper = PageReduxProvider;
